module.exports = __webpack_public_path__ + "static/media/group-quote-small.ba0eee49.jpg";